export default __webpack_public_path__ + "static/media/button-android.998b41d7.png";